<div
  class="team-item cursor-pointer"
  appIntersectionAnimate
  [isAnimateActive]="isAnimate()"
  [extraClass]="odd() ? 'reverse' : ''"
  [routerLink]="link()"
>
  <div class="team-images">
    <img
      decoding="async"
      [src]="image()"
      class="object-cover max-h-[380px]"
      alt=""
    >
    @if (recommended()) {
      <div class="absolute top-0 right-0 z-10">
        <div class="bg-amber-400 text-primary px-3 py-1.5 text-[10px] font-black uppercase tracking-widest rounded-bl-xl shadow-sm flex items-center gap-1.5">
          <span class="material-symbols-outlined text-[14px]! font-bold">verified</span>
          <span>Recomendado</span>
        </div>
      </div>
    }
  </div>

  <div class="team-content ">
    <div class="team-text min-h-[92px]">
      <h5 class="title font-bold font-heading text-xl">
        <a [routerLink]="link()">
          {{ name() }} </a>
      </h5>
      @if (position()) {
        <span class="sub-title">{{ position() }}</span>
      }
      @if (tags().length > 0) {
        <div class="flex flex-wrap gap-2 mt-2">
          @for (tag of tags().slice(0, 2); track tag) {
            <span class="px-2 py-1 bg-secondary text-white text-xs rounded-full">
              {{ tag?.title }}
            </span>
          }
        </div>
      }
    </div>
    <div class="team-share">
      <ul>
        <!-- <li>
          <a href="https://www.facebook.com/">
            <i class="fa-brands fa-facebook-f"></i>
          </a>
        </li>
        <li>
          <a href="https://x.com/">
            <i class="fa-brands fa-twitter"></i>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/">
            <i class="fa-brands fa-instagram"></i>
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/">
            <i class="fa-brands fa-linkedin-in"></i>
          </a>
        </li> -->
        <li (click)="$event.stopPropagation()">
          @if (icon()) {
            <a>
              <img
                [src]="icon()"
                alt="Contact icon"
                class="w-6 h-6 object-contain"
              >
            </a>
          } @else {
            <a href="#">
              <i class="fa-brands fa-whatsapp"></i>
            </a>
          }          
        </li>
      </ul>
    </div>
  </div>
</div>